import TopicList from '../../../../../ui/list/topicList/TopicList';

interface ESGTopicTrendCompanyListsProps {
  trends?: any[];
}

const ESGTopicTrendCompanyLists = ({ trends = [] }: ESGTopicTrendCompanyListsProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-cols-4 gap-4">
      {trends.map((trend, index) => (
        <TopicList topic={trend} rank={index + 1} key={index} />
      ))}
    </div>
  );
};

export default ESGTopicTrendCompanyLists;
